import React from "react"
// import { Link } from "gatsby"
import Layout from "../components/layout"
import Hero from "../components/hero"
import Img from "../assets/images/v2026/buses/fpb1-hero.webp"
import BlockBuses from '../components/buses/blockTpBuses'
import { BusUrbano, BusInterprovincial, BusParaPersonalDeLima } from '../data/buses'

const Data = [
  BusUrbano.linea,
  BusInterprovincial.linea,
  BusParaPersonalDeLima.linea,
]
export default function Buses() {
  return (
    <>
       <Layout
        img={Img}
        title="Buses"
        description="Nuestros buses: OLYMPO URBANO, OLYMPO TURISMO, OLYMPO MINA"
      >
        <Hero img={Img} title="buses" clase="bgbuses"></Hero>
        {/* <div className="container"> */}
          <BlockBuses tipo='page' data={Data}></BlockBuses>
        {/* </div> */}
      </Layout>
    </>
  )
}
